import { api } from "@/redux/api";

import {
	ListOwnershipCounts,
	ListOwnershipCountsSchema,
} from "../../pages/List/schema/list-ownership-counts";

/**
 * List-overview tab count bubbles (PREC-3623). Split into its own `injectEndpoints` file because
 * the main `list.api.ts` is at the file-length ratchet ceiling and may not grow; RTK Query supports
 * injecting endpoints into the same base `api` across files.
 *
 * Tagged `List` so the bubbles refetch whenever a list is created / archived / deleted / reset —
 * those mutations invalidate the broad `List` tag.
 */
export const listOwnershipCountsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getListOwnershipCounts: builder.query<ListOwnershipCounts, void>({
			query: () => ({
				url: "list/ownership-counts",
				responseSchema: ListOwnershipCountsSchema,
			}),
			providesTags: ["List"],
		}),
	}),
});

export const { useGetListOwnershipCountsQuery } = listOwnershipCountsApi;
